import { Menu, MenuButton, MenuItems, Transition } from '@headlessui/react';
import classNames from 'classnames';
import { ReactNode } from 'react';
import { NotificationButton } from '../buttons/NotificationButton';
import { DROPDOWN_TRANSITION } from './constants';
import { ButtonType } from '../buttons/ButtonType';
import { IconType } from '../../../constants';
import { ThemePopup } from '../../../context/theme/ThemeConstantsUpdated';

const { background, border, mainText } = ThemePopup;

export const NotificationDropdown = (props: Props) => {
  const { children, buttonType, notificationAmount, Icon, onClick, title } = props;

  return (
    <Menu as="div" className="relative flex justify-center align-middle">
      {({ open }) => (
        <>
          <MenuButton className="flex items-center rounded-full">
            <NotificationButton
              buttonType={buttonType}
              notificationAmount={open ? 0 : notificationAmount}
              Icon={Icon}
              onClick={onClick}
            />
          </MenuButton>
          <Transition {...DROPDOWN_TRANSITION}>
            <MenuItems
              as="div"
              className={classNames(
                background,
                'absolute right-0 top-9 z-10 mt-2 w-[400px] origin-top-right rounded-md text-left shadow-md focus:outline-none'
              )}
            >
              <div className={classNames(border, 'border-b px-4 py-3')}>
                <h3 className={classNames(mainText, 'truncate text-sm font-semibold')}>{title}</h3>
              </div>
              <div className="max-h-[400px] overflow-y-auto">{children}</div>
            </MenuItems>
          </Transition>
        </>
      )}
    </Menu>
  );
};

type Props = {
  title: string;
  buttonType?: ButtonType;
  children: ReactNode;
  notificationAmount: number | true;
  Icon: IconType;
  onClick?: () => void;
};
